<header id="results-header" [ngClass]="getClassHeader()">
    <!-- style="margin-left:35px;margin-right:35px;"-->
    <nav *ngIf="headerType !== 'results' && headerType != 'singleHotel' && headerType !== 'booking' && headerType !== 'voucher'"
        class="navbar navbar-expand-lg  main-nav col-md-12"
        [ngStyle]="headerType === 'voucher'?{'z-index': '9999', 'position': 'absolute'}: {'z-index': '9999'}">
        <a href="#" id="logo" class="col-md-3"></a>
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarText"
            aria-controls="navbarText" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarText">
            <ul id="" class="navbar-nav mr-auto left-nav col-md-5" style="background: none;height:5em;">
                <li *ngIf="headerType !=='booking' && headerType !== 'voucher'" class="tripSummary"
                    style="height: 63px;">
                    <div class="destination" style="height: auto;text-align: center;display:block">Destination:
                        <span>Crete</span>
                    </div>
                    <div class="tripDates clear">
                        <div class="checkin">
                            <span>Check-in</span>
                            <span *ngIf="request">{{getFormatedDate(request.fromdate)}}</span>
                        </div>
                        <div class="checkout">
                            <span>Check-out</span>
                            <span *ngIf="request">{{getFormatedDate(request.todate)}}</span>
                        </div>
                    </div>
                </li>
                <li id="itinerary">
                    <a *ngIf="headerType !=='booking' && headerType !== 'voucher'" routerLink="/">Add another
                        interval</a>
                </li>
            </ul>
            <div class="justify-content-end right-navigation">
                <app-right-navigation [userlogged]="userlogged" [isBooking]="true" [userInfo]="userInfo"
                    [unreadMessages]="unreadMessages" (logout)="logoutUser($event)"
                    (openLoginModal)="openLoginModal($event)">
                </app-right-navigation>
            </div>
        </div>
    </nav>

    <nav *ngIf="headerType == 'results' || headerType == 'singleHotel' || headerType == 'booking' || headerType === 'voucher'"
        class="navbar navbar-expand-lg  main-nav col-md-12" [ngStyle]="{'z-index': '9999', 'background': '#fff'}">
        <span class="left-navigation-toggler" style="font-size:30px;cursor:pointer;color: #313232;margin-left:20px;"
            (click)="openNav()">&#9776;</span>
        <a href="#" id="logo"></a>
        <div class="collapse navbar-collapse" id="navbarText"
            style="display: flex!important; flex-basis: auto;justify-content: flex-end;">
            <ul *ngIf="headerType !== 'booking' && headerType !== 'voucher'" id=""
                class="navbar-nav mr-auto left-nav col-md-5 results-info-nav" style="background: none;height:5em;">
                <li class="info-list">
                    <span> Destination:<br> Crete</span>
                </li>
                <li class="info-list">
                    <div class="checkin">
                        <span *ngIf="request">Check-in <br>
                            {{getFormatedDate(request.fromdate)}}</span>
                    </div>
                </li>
                <li class="info-list">
                    <div class="checkout">
                        <span *ngIf="request">Check-out<br>
                            {{getFormatedDate(request.todate)}}</span>
                    </div>
                </li>
                <li class="info-list">
                    <div class="checkout roomPeopleHeader">
                        <span *ngIf="request"> {{getAdults()}} Adults, {{getChildren()}} Children<br>
                            {{request.rooms}} room</span>
                    </div>
                </li>
                <li class="info-list">
                    <div>
                        <span class="nightCounter" style="margin-top: 20px;">
                            <span>{{getNights(request.fromdate, request.todate)}}</span><br>
                            <span class="nights">nights</span>
                        </span>
                    </div>
                </li>
            </ul>
            <div class="justify-content-end right-navigation">
                <app-right-navigation [userlogged]="userlogged" [userInfo]="userInfo" [isResults]="true"
                    [headerType]="headerType" [unreadMessages]="unreadMessages" (logout)="logoutUser($event)"
                    (openLoginModal)="openLoginModal($event)">
                </app-right-navigation>
            </div>
        </div>
    </nav>
    <ul *ngIf="headerType == 'results' || headerType == 'singleHotel'" id="" class="row results-info-nav-mobile">
        <li class="info-list col-sm-3 col-3" style="border: none;">
            <span> Destination:<br> <span class="txt-grey">Crete</span></span>
        </li>
        <li class="info-list col-sm-3 col-3">
            <div class="checkin">
                <span *ngIf="request">
                    {{getFormatedDate(request.fromdate)}} to <br>
                    {{getFormatedDate(request.todate)}}
                </span>
            </div>
        </li>
        <li class="info-list col-sm-4 col-4">
            <div class="checkout">
                <span *ngIf="request" class="txt-grey"> {{getAdults()}} Adults, {{getChildren()}} Children<br>
                    {{request.rooms}} room
                </span>
            </div>
        </li>
        <li class="info-list col-sm2 col-2">
            <div>
                <span class="nightCounter" style="margin-top: 20px;">
                    <span>{{getNights(request.fromdate, request.todate)}}</span><br>
                    <span class="nights txt-grey">nights</span>
                </span>
            </div>
        </li>
    </ul>


    <div id="headerSorting" class="row" *ngIf="headerType && headerType !== 'results' && headerType !== 'singleHotel'">
        <div [ngClass]="(headerType === 'booking' || headerType === 'voucher')? 'col-md-12': 'col-md-3'"
            [ngStyle]="(headerType === 'booking' || headerType === 'voucher' || headerType === 'results')? {'max-height': '110px'}: {'padding-top': '25px'}">
            <ul *ngIf="headerType !== 'booking' && headerType !== 'voucher'" class="clear" id="my-menu"
                [ngStyle]="headerType === 'voucher'?{'margin-top': '4.2em'}: ''">
                <li>
                    <a class="icon icon-offer" routerLink="/my-dashboard/my-requests" title="My Requests"></a>
                </li>
                <li>
                    <a class="icon icon-bookings" routerLink="/my-dashboard/my-bookings" title="My Bookings"></a>
                </li>
                <li>
                    <a class="icon icon-settings" routerLink="/my-dashboard/my-settings" title="My Settings"></a>
                </li>
            </ul>
        </div>

        <div [ngClass]="headerType === 'booking' || headerType === 'voucher'? 'col-md-12 header-info': 'col-md-9 header-info'"
            [ngSwitch]="headerType">
            <div class="row" *ngSwitchCase="'booking'">
                <div class="col-md-10 hotel-title-info" style="margin-top:15px">
                    <div class="titles">
                        <h2>Book your stay</h2>
                        <span>Secure booking in 2 quick steps</span>
                    </div>
                </div>
                <div class="col-md-2">
                    <div class="backBtn float-right" style="margin-top:30px;">
                        <a (click)="goBack()">Back to room selection</a>
                    </div>
                </div>
            </div>
            <div class="row" *ngSwitchCase="'voucher'">
                <div id="headerSorting" class="clear col-md-12" style="padding:0;margin-top:35px">
                    <div class="titles">
                        <h2>Great, you are ready</h2>
                        <span>Your secure booking is completed</span>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div id="headerSorting" class="row header-single" *ngIf="headerType === 'singleHotel'" style="margin: 0;">
        <div class="col-md-4 offset-md-2 col-sm-6 col-6 hotel-title-info" style="padding-top:25px">
            <h1 *ngIf="hotelInfo">
                <span>{{hotelInfo.title}}</span>
                <span class="stars">
                    <span *ngFor="let item of getArray(hotelInfo.stars)" class="icon icon-star"></span>
                </span>
                <span class="address">{{hotelInfo.location}}</span>
            </h1>
        </div>
        <div class="col-md-2 col-sm-3 col-3" style="padding-top:25px;padding-right:0">
            <div class="price header-price" *ngIf="hotelInfo">
                <span class="value">{{hotelInfo.cost}}€</span><br>
                <span class="txt" style="top: -6px;position: relative;">total booking</span>
            </div>
        </div>
        <div class="col-md-2 col-sm-3 col-3" style="padding-top:25px;padding-left:0">
            <div class="bookNow">
                <a (click)="bookNow()">Book now</a>
            </div>
        </div>
        <div class="col-md-2 single-hotel-back" style="padding-left:0">
            <div class="backBtn float-right">
                <a (click)="goBack()">Back to my offers</a>
            </div>
        </div>
    </div>
</header>

<app-login-view #loginModal (modalClosed)="modalClosed($event)"></app-login-view>